import { Button } from "@mui/material";


export default function DeleteProductButton({ selectedCount, onClick }) {
  return (
    <Button
      variant="contained"
      color="error"
      onClick={onClick}
      disabled={selectedCount === 0}
      sx={{
        mt: 2,
        width: "13.2vw",
        height: "7.6vh",
        ml: 1,
        fontSize: { md: "12px", sm: "10px" },
      }}
    >
      Eliminar: {selectedCount}
    </Button>
  );
}
